<template>
  <div>
    <ComponentTests />
  </div>
</template>

<script>
import ComponentTests from "ninenine-white-label/src/components/Tests/ComponentTests.vue";

export default {
  name: "Tests",

  components: {
    ComponentTests,
  },
};
</script>
<style lang="scss" scoped>
  /deep/ .alert-circle-icon svg {
    width: 80px;
    height: 80px;
  }
</style>
